import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function ChangePartner({ onSelect, onClose }) {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  const loadData = async () => {
    try {
      const response = await axios.get('https://megamont.pl/api/partners');
      setPartners(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Błąd ładowania partnerów:', error);
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, []);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || uploading) return;

    const formData = new FormData();
    formData.append('partnerImage', file);

    setUploading(true);
    try {
      const response = await axios.post('https://megamont.pl/api/partners', formData);
      
      // ZAMIAST natychmiastowego onSelect, najpierw czyścimy input i informujemy użytkownika
      if (response.data && response.data.partner) {
          // Opóźnienie wywołania onSelect pozwala modalowi "przeżyć" operację uploadu
          setTimeout(() => {
              onSelect(response.data.partner);
          }, 100);
      }
    } catch (err) {
      alert("Błąd podczas wgrywania pliku.");
      setUploading(false);
    }
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1060 }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title fw-bold">Dodaj Partnera</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={uploading}></button>
          </div>
          <div className="modal-body p-4">
            <div className="upload-section mb-4 p-4 border rounded bg-light text-center">
              <h6 className="fw-bold">Wgraj nowe logo partnera na serwer</h6>
              <input type="file" id="newPartFile" hidden onChange={handleFileUpload} accept="image/*" disabled={uploading} />
              <label htmlFor="newPartFile" className={`btn ${uploading ? 'btn-secondary' : 'btn-success'} px-4`}>
                {uploading ? "Wgrywanie..." : "Wybierz plik z dysku"}
              </label>
            </div>
            <div className="d-flex align-items-center my-3">
              <hr className="flex-grow-1" /> <span className="mx-2 text-muted small">LUB WYBIERZ Z ISTNIEJĄCYCH</span> <hr className="flex-grow-1" />
            </div>
            {loading ? (
              <div className="text-center py-4"><div className="spinner-border text-primary"></div></div>
            ) : (
              <div className="row g-2" style={{ maxHeight: '40vh', overflowY: 'auto' }}>
                {partners.map((partner) => (
                  <div className="col-md-3 col-6" key={partner.id} onClick={() => !uploading && onSelect(partner)}>
                    <div className="card h-100 p-2 text-center border-hover" style={{ cursor: 'pointer' }}>
                      <img src={`https://megamont.pl/uploads/partners/${partner.name}`} className="img-fluid" style={{ height: '60px', objectFit: 'contain' }} alt="" />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}